import * as React from 'react';
import System from "src/helper/system";

const ThankYouPopup = (props) => {
    const { SetStatus, data } = props;
    const getTitleText = () => {
        if ((data.isQuote !== undefined && data.isQuote) || data?.isOrderReturn) {
            return 'Confirmation';
        }
        if (data.isOrderHistory !== undefined && data.isOrderHistory) {
            return ' Thanks for your request';
        }
        if (data?.isRegister) {
            return 'Thank You';
        }
        return 'Feedback Received';
    }
    const getBodyText = () => {
        if (data.isPDP !== undefined && data.isPDP === true) {
            return 'Many thanks for your feedback, our experts will look into this.'
        }
        if (data.isQuote !== undefined && data.isQuote === true) {
            return 'Your message has been sent successfully.'
        }
        if (data.isOrderHistory !== undefined && data.isOrderHistory === true) {
            return 'We will send your order history details to your account email.'
        }
        if (data?.isRegister) {
            return (
                <p>
                    You will receive an email with the temporary password. If you don't receive this email contact: Online Support
                    EMEA Phone: 00800 412 412 11 or <a href="mailto:OnlineSupportEU@avnet.com">OnlineSupportEU@Avnet.com</a>
                </p>
            )
        }
        if(data?.isOrderReturn)
            {
                return (
                    <p>
                        Your return request has been submitted successfully. An email will be forwarded to you
                        with your return request information and a sales representative will contact you.
                    </p>
                )
            }
        return 'Your email has been sent.'
    }
    return (
        <>
            <div className="avnet-modal modal-630">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    {!data?.isRegister && (

                        <button type="button" className="close" data-dismiss="modal"
                            onClick={() => {
                                SetStatus(false)
                            }}>×
                        </button>
                    )}
                    <div className="modal-header justify-content-center">
                        <h1 className="pcn-modal-heading ps-4 pe-4">
                            {data?.isRegister ?
                                <span className='text-darkgreen'>{getTitleText()} </span>
                                : getTitleText()}
                        </h1>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body">
                        <div className="text-center mb-3">
                            {
                                /**
                                    * CR #      : 7977
                                    * Change    : Optimize code and order history message change
                                    * Change by : Pankaj
                                    * Date      : 01 Feb 2023
                                    * */
                            }
                            {getBodyText()}
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-primary minw-auto"
                                onClick={() => {
                                    if (data?.isRegister) {
                                        window.location.href = System.getPreviousPageUrl()
                                    } else {
                                        SetStatus(false)
                                    }
                                }}
                            >
                                {(data?.isOrderReturn || data.isOrderHistory) ? 'Close' : data?.isRegister ? 'CONTINUE' : 'Ok'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ThankYouPopup;